import config from "@/config";

// Paths definidos en el relay (deploy/mediamtx.yml). Cada path = video + UNA
// pista de audio mux'eada; para cambiar de canal de audio se cambia de path
// y se reconecta (MediaMTX no expone múltiples pistas en un mismo stream WHEP).
export interface RelayChannel {
  id: string;
  label: string;
}

export const RELAY_CHANNELS: RelayChannel[] = [
  { id: "feed_audio_a", label: "Video 1 · Audio A" },
  { id: "feed_audio_b", label: "Video 1 · Audio B" },
  { id: "feed_audio_c", label: "Video 2 · Audio A" },
  { id: "feed_audio_d", label: "Video 2 · Audio B" },
];

/** URL WHEP completa para un path de MediaMTX. */
export function whepUrl(channelId: string): string {
  const base = config.RELAY_WHEP_BASE.replace(/\/$/, "");
  return `${base}/${channelId}/whep`;
}
